import { Directive, HostBinding, inject, input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ancShowFieldError } from './anc-show-field-error.util';

/**
 * Applies `is-invalid` to a control (`input`, `textarea`, `ng-select`)
 * when invalid and dirty or submitted.
 *
 * @example
 * <input class="form-control" formControlName="sku"
 *   ancFieldValidate [ancFieldValidateSubmitted]="submitted" />
 */
@Directive({
    selector: '[ancFieldValidate]',
    standalone: true
})
export class AncFieldValidateDirective {
    private readonly ngControl = inject(NgControl, { self: true, optional: true });

    /** When true, invalid controls show error styling even if pristine. */
    submitted = input(false, { alias: 'ancFieldValidateSubmitted' });
    /** Cross-field / group-level error targeting this control (e.g. retail vs selling price). */
    forceInvalid = input(false, { alias: 'ancFieldValidateForceInvalid' });

    @HostBinding('class.is-invalid')
    get invalid(): boolean {
        return ancShowFieldError(
            this.ngControl?.control ?? null,
            this.submitted(),
            this.forceInvalid()
        );
    }
}
